import React__default from 'react';

var SkeletonBar = function SkeletonBar() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "h-3 w-full animate-pulse rounded bg-[#eaeaea]"
  });
};
var ObfuscationSkeletonCompany = function ObfuscationSkeletonCompany() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "grid gap-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "grid gap-2"
  }, /*#__PURE__*/React__default.createElement(SkeletonBar, null), /*#__PURE__*/React__default.createElement(SkeletonBar, null), /*#__PURE__*/React__default.createElement(SkeletonBar, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "grid gap-2"
  }, /*#__PURE__*/React__default.createElement(SkeletonBar, null)), /*#__PURE__*/React__default.createElement(SkeletonBar, null));
};
var ObfuscationSkeletonContact = function ObfuscationSkeletonContact() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "grid gap-4 max-sm:col-span-2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "grid gap-2"
  }, /*#__PURE__*/React__default.createElement(SkeletonBar, null), /*#__PURE__*/React__default.createElement(SkeletonBar, null), /*#__PURE__*/React__default.createElement(SkeletonBar, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "grid gap-2"
  }, /*#__PURE__*/React__default.createElement(SkeletonBar, null), /*#__PURE__*/React__default.createElement(SkeletonBar, null)), /*#__PURE__*/React__default.createElement(SkeletonBar, null));
};

export { ObfuscationSkeletonCompany, ObfuscationSkeletonContact };
//# sourceMappingURL=obfuscation-skeleton.esm.js.map
